
import React from "react";

const Knowledge = () => {
  return (
    <div className="flex flex-col gap-4">
        <h1 className="text-4xl font-bold text-[#22BEFF]">
        KNOWLEDGE MAPPING TEST{" "}
      </h1>
    </div>
  );
};

export default Knowledge;
